import type * as Types from 'app/types/graphql';

import {
  GemXqlResultSelectFragmentDoc,
  TableDataSelectFragmentDoc,
  ColumnSelectFragmentDoc,
} from '../fragments/gemxql.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type GemxQlQueryVariables = Types.Exact<{
  input: Types.Scalars['String']['input'];
}>;

export type GemxQlQueryResponse = {
  gemxQLQuery?: Types.Maybe<{
    tableData?: Types.Maybe<
      Pick<Types.TableData, 'rows'> & {
        columns?: Types.Maybe<
          Array<Types.Maybe<Pick<Types.Column, 'dataType' | 'displayName' | 'name'>>>
        >;
      }
    >;
  }>;
};

export const GemxQlDocument = `
    query GemxQL($input: String!) {
  gemxQLQuery(query: $input) {
    ...GemXQLResultSelect
  }
}
    ${GemXqlResultSelectFragmentDoc}
${TableDataSelectFragmentDoc}
${ColumnSelectFragmentDoc}`;

export const useGemxQlQuery = <TData = GemxQlQueryResponse, TError = unknown>(
  variables: GemxQlQueryVariables,
  options?: UseQueryOptions<GemxQlQueryResponse, TError, TData>,
) => {
  return useQuery<GemxQlQueryResponse, TError, TData>(
    ['GemxQL', variables],
    appFetcher<GemxQlQueryResponse, GemxQlQueryVariables>(GemxQlDocument, variables),
    options,
  );
};

useGemxQlQuery.getKey = (variables: GemxQlQueryVariables) => ['GemxQL', variables];
